import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { LiveSourcesStateService } from '../../../services/live-sources/live-sources-state.service';
import { LiveSourcesRepository } from '../../../infrastructure/repositories/live-sources/live-sources.repository';
import {
  LiveSourceStatusFilter,
  LiveSourceProtocolFilter,
} from '../../../domain/live-sources';

@Component({
  selector: 'evrideo-live-sources-container',
  templateUrl: './live-sources-container.component.html',
  styleUrls: ['./live-sources-container.component.scss'],
})
export class LiveSourcesContainerComponent implements OnInit, OnDestroy {
  private loadSub?: Subscription;

  constructor(
    public state: LiveSourcesStateService,
    private repository: LiveSourcesRepository,
  ) {}

  ngOnInit(): void {
    this.loadAllData();
  }

  ngOnDestroy(): void {
    this.loadSub?.unsubscribe();
    this.state.reset();
  }

  /** Load all live sources from the backend API. */
  loadAllData(): void {
    this.state.setLoading(true);
    this.state.setError(null);

    this.loadSub?.unsubscribe();
    this.loadSub = this.repository.getSources().subscribe({
      next: (sources) => {
        this.state.setSources(sources);
        this.state.setLoading(false);
      },
      error: (err) => {
        this.state.setError(err?.message ?? 'Unable to load live sources');
        this.state.setLoading(false);
      },
    });
  }

  onSearchChange(query: string): void {
    this.state.setSearchQuery(query);
  }

  onStatusChange(status: LiveSourceStatusFilter): void {
    this.state.setStatusFilter(status);
  }

  onProtocolChange(protocol: LiveSourceProtocolFilter): void {
    this.state.setProtocolFilter(protocol);
  }

  onDeleteSource(id: string): void {
    this.repository.deleteSource(id).subscribe({
      next: () => this.loadAllData(),
      error: (err) => {
        this.state.setError(err?.message ?? 'Failed to delete source');
      },
    });
  }
}
